<script setup lang="ts">
import StackLayout from '@/components/Layouts/StackLayout.vue'
import { ref } from 'vue'
import OPTField from '../../../components/Fields/OPTField.vue'
import BaseDialog from '../../../components/Modals/Dialog/BaseDialog.vue'
import TypographyItem from '../../../components/Typography/TypographyItem.vue'

type Props = {
    open: boolean
    loading: boolean
}
defineProps<Props>()
type Emits = {
    (e: 'close'): void
    (e: 'confirm', code: string): void
}
const emit = defineEmits<Emits>()

const authenticator = ref<string>()
const trustDevice = ref<boolean>()
const isSubmitted = ref(false)

const handleClose = () => {
    console.log({ otpRef: otpRef.value })
    otpRef.value?.clearInput()
    authenticator.value = undefined
    trustDevice.value = undefined
    emit('close')
}

const handleConfirm = () => {
    if (!authenticator.value) return (isSubmitted.value = true)
    isSubmitted.value = false
    emit('confirm', authenticator.value)
}

const otpRef = ref<{ clearInput: () => void }>()
</script>

<template>
    <BaseDialog :open="open" @close="handleClose" @confirm="handleConfirm">
        <template #content>
            <StackLayout :gap="16" direction="column">
                <TypographyItem :label="$t('account.twoFa.authCode')" />
                <OPTField
                    ref="otpRef"
                    :modelValue="authenticator"
                    @change="authenticator = $event"
                    @complete="$emit('confirm', $event)" />
                <!-- <CheckboxField
                    :label="$t('authentication.twoFa.rememberDevice')"
                    :value="trustDevice"
                    @click="trustDevice = $event ? $event : undefined"
                    class="align-self-center" /> -->
            </StackLayout>
        </template>
    </BaseDialog>
</template>

<style scoped lang="scss"></style>
